import { render, staticRenderFns } from "./physicalProperty.vue?vue&type=template&id=2349ccf7&scoped=true&"
import script from "./physicalProperty.vue?vue&type=script&lang=js&"
export * from "./physicalProperty.vue?vue&type=script&lang=js&"
import style0 from "./physicalProperty.vue?vue&type=style&index=0&id=2349ccf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349ccf7",
  null
  
)

export default component.exports